import type { StudentSkillRow } from "@edu/shared";
import { GRADE_UNKNOWN, confidenceWord, wrongText } from "./student-skills-text.ts";

/**
 * Тема строкой в панели «Где дыры».
 *
 * ⚠️ **Знаменатель и слово надёжности стоят у КАЖДОЙ строки**, включая те, что
 * держатся: вердикт без знаменателя это то же самое, что процент верных
 * ответов, за который мы ругаем чужие продукты (2.1 проекта, решение владельца
 * 21.08.2026).
 *
 * ⚠️ **Тревожного цвета здесь нет ни у чего**: ни у строки, ни у чисел, ни у
 * корня. Правило перенесено дословно из `docs/student-marks-design.md`, раздел
 * 4: это диагноз, а не авария, и алый цвет превратил бы работу преподавателя в
 * его ошибку. По той же причине у строки нет и чипа состояния: чип с заливкой
 * есть ровно у `danger`, и другого способа прочитать его нет.
 *
 * Класс программы стоит вторым слотом намеренно: «5-6 класс» рядом с «8 класс»
 * это и есть глубина пробела, ради которой поле заведено.
 */
export function SkillLine(props: {
  row: StudentSkillRow;
  /** Вторая строка под названием: откуда идёт следствие. */
  note?: string | undefined;
}) {
  const { row } = props;

  return (
    <li className="row">
      <span className="cell row__name">
        {row.name}
        {props.note !== undefined && props.note !== "" && (
          <span className="row__sub">{props.note}</span>
        )}
      </span>

      {/* Слот занят словами и тогда, когда класса нет: пустой слот схлопывается,
          и строки списка перестают сравниваться взглядом */}
      <span className="cell" data-label="Класс">
        {row.grade ?? <span className="row__void">{GRADE_UNKNOWN}</span>}
      </span>

      <span className="cell" data-label="Ошибки">
        {wrongText(row.wrong, row.tasks)}
      </span>

      <span className="cell row__void" data-label="Надёжность">
        {confidenceWord(row.confidence)}
      </span>
    </li>
  );
}
